/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React from "react";
import { FileUploaderItem } from "@carbon/react";

export default (props) => {
  return <FileUploaderItem {...props} />;
};
